<div class="p-4">
  <mat-dialog-content>
    @if (!loading()) {
      <div class="flex flex-col gap-4">
        <div class="flex items-center justify-between gap-2">
          <h3>{{ "prescription.action.cancelAppointment" | translate }}</h3>
          <button mat-dialog-close>
            <mat-icon
              aria-hidden="true"
              aria-label="Close icon"
              [fontIcon]="'close'"
            ></mat-icon>
          </button>
        </div>

        <shared-warning-message
          [text]="'appointments.descriptions.cancellationWarning' | translate: { partner: partnerName(), location: address() }"
          [subText]="'appointments.descriptions.cancellationDetails' | translate: { dateTime: startDate() }"
        ></shared-warning-message>

        @if (data.prescription) {
          <prescriptions-modal-item [prescription]="data.prescription" />
        }
      </div>
    } @else {
      <div class="flex items-center justify-center">
        <shared-loader></shared-loader>
      </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions class="gap-4">
    @if (!loading()) {
      <button
        mat-dialog-close
        class="btn btn-secondary"
        [type]="'button'"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button
        class="btn btn-primary"
        [type]="'button'"
        (click)="confirmCancellation()"
      >
        {{ "prescription.action.cancelAppointment" | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
